module.exports = __webpack_public_path__ + "img/user_icon.e66a3add.jpg";